module.exports = __webpack_public_path__ + "images/relate-both-cards.a683c0c009f39a275ce4.png";